// --------------------- Import Global ---------------------
import { useState } from "react";
// --------------------- Import Úteis ---------------------
import { numberPadrao } from "../../../uteis/formatPhoneNumber";
// --------------------- Import Services ---------------------
import { cadastrarLead } from "../../../services/cadastrarLeadService";
import { buscarLeadsByCelService } from "../../../services/buscarLeadsByCelService";
import { buscarFonteByNameService } from "../../../services/buscarFonteByNameService";
import { buscarGrupoByNameService } from "../../../services/buscarGrupoByNameService";
import { cadastrarFonteService } from "../../../services/cadastrarFonteService";
import { cadastrarGrupoService } from "../../../services/cadastrarGrupoService";
import { cadastrarPostagemService } from "../../../services/cadastrarPostagemService";
import { buscarUsuarioProprietarioByCel } from "../../../services/buscarUsuarioProprietarioByCelService";
import { PostagemData } from "../Interface/PostagemData";
import dayjs from "dayjs";

export const useCadastrarPostagem = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);
  const [warning, setWarning] = useState<string | null>(null);

  const resetError = () => setError(null);
  const resetSuccess = () => setSuccess(null);
  const resetWarning = () => setWarning(null);

 const obterOuCadastrarLead = async (data: PostagemData) => {
   
    const celularFormatado = numberPadrao(data.celular);

     // 1. Primeiro: procura Lead existente
    const leadExistente = await buscarLeadsByCelService(celularFormatado);

    if (leadExistente) {
      return leadExistente.id;
    }

      // 2. Procura proprietário
    const usuarioProprietario = await buscarUsuarioProprietarioByCel(
      celularFormatado
    );

    // cria um lead com mesmo idPessoa de proprietário.
    if (usuarioProprietario) {
       const leadProprietario = await cadastrarLead({
      nome: `${usuarioProprietario.nome} ${usuarioProprietario.sobrenome || ""}`,
      celular: celularFormatado,
      active: 1,
      status: "DIVULGAR",
      tipo: "PROPRIETARIO",
      
      
    });

    return leadProprietario.id;

    }

     // 3. Caso não exista nada: cria Lead normal
    const novoLead = await cadastrarLead({
      nome: data.nome,
      celular: celularFormatado,
      active: 1,
      status: "DIVULGAR",
      tipo: "LEAD",
     
    });

    return novoLead.id;
  };


  const obterOuCadastrarFonte = async (nomeFonte: string) => {
    const fonte = await buscarFonteByNameService(nomeFonte);
    return fonte
      ? fonte.id
      : (await cadastrarFonteService({ nome: nomeFonte, active: 1 })).id;
  };

  
  const obterOuCadastrarGrupo = async (nomeGrupo?: string | null) => {
    // 🚫 Se o nome do grupo estiver vazio ou nulo, não tenta buscar/cadastrar
    if (!nomeGrupo || nomeGrupo.trim() === "") return null;

    const grupo = await buscarGrupoByNameService(nomeGrupo);
    return grupo
      ? grupo.id
      : (await cadastrarGrupoService({ nome: nomeGrupo, active: 1 })).id;
  };

  const verificarLimiteData = (
    dataIni?: string | Date,
    dataFim?: string | Date
  ) => {
    if (!dataIni || !dataFim) return true;

    const ini = dayjs(dataIni);
    const fim = dayjs(dataFim);

    if (fim.isBefore(ini, "day")) {
      return false;
    }

    return true;
  };
  const verificarPeriodoDisponibiliza = (
    dataIni?: string | Date,
    dataFim?: string | Date
  ) => {
    if (!dataIni || !dataFim) return true;

    const ini = dayjs(dataIni);
    const fim = dayjs(dataFim);
    const diff = fim.diff(ini, "day");

    if (diff > 7) {
      return false;
    }

    return true;
  };
  const cadastrar = async (data: PostagemData) => {
    setIsLoading(true);
    setError(null);
    setSuccess(null);

    try {
      if (!verificarLimiteData(data.dataIni, data.dataFim)) {
        setWarning("A data fim não pode ser menor que a data início.");
        return false;
      }

      if (data.tipoInteresse === "DISPONIBILIZA") {
        const validacaoDisponibiliza = verificarPeriodoDisponibiliza(
          data.dataIni,
          data.dataFim
        );
        if (!validacaoDisponibiliza) {
          setWarning(
            "O período de disponibilização não pode ser maior que 7 dias."
          );
          return false;
        }
      }
      const idLead = await obterOuCadastrarLead(data);

      const idFonte = await obterOuCadastrarFonte(data.fonte);

      const idGrupo = await obterOuCadastrarGrupo(data.grupo);

       

      const postagemData: any = {
        idLeads: idLead,
        idFonte,
        idEmpreendimento: data.idEmpreendimento,
        active: 1,
        dataDivulgacao: data.dataDivulgacao,
        tipoInteresse: data.tipoInteresse,
        troca: data.troca,
        aluguel: data.aluguel,
        compra: data.compra,
        venda: data.venda,
        dataIni: data.dataIni,
        dataFim: data.dataFim,
        observacoes: data.observacoes || "",
      };

       if (idGrupo) postagemData.idGrupo = idGrupo;

      const postagemCriada = await cadastrarPostagemService(postagemData);

      if (postagemCriada) {
        setSuccess("Informação cadastrada com sucesso.");
        return true;
      } else {
        setError("Erro ao cadastrar a postagem.");
        return false;
      }
    } catch (error) {
      console.error(error);
      setError("Erro inesperado ao cadastrar a postagem.");
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    cadastrar,
    isLoading,
    success,
    error,
    warning,
    resetWarning,
    resetError,
    resetSuccess,
  };
};
